/**
 * Returns true when recordOwner matches any of the current user's Cognito identities.
 * Amplify owner fields may be the username, sub, or "sub::username".
 */
export function isRecordOwner(
  recordOwner: string | null | undefined,
  identities: (string | null | undefined)[]
): boolean {
  if (!recordOwner) return false;

  const ids = identities.filter((id): id is string => Boolean(id));
  if (ids.length === 0) return false;

  if (ids.includes(recordOwner)) return true;

  if (recordOwner.includes("::")) {
    const [sub, username] = recordOwner.split("::");
    return ids.includes(sub) || ids.includes(username);
  }

  return false;
}
